import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

export default class LogoIcon extends Component {
    static defaultProps = {
        size: 32
    };

    static propTypes = {
        size: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number,
        dark: PropTypes.bool
    };

    render() {
        let { dark, height, width, size } = this.props;
        return (
            <svg className={cx('Icon', {"text-brand": !dark }, { "text-white": dark })} viewBox="0 0 66 85" width={width || size} height={height || size} fill="currentcolor">
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/LogoIcon.jsx